import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AdminProvider } from './contexts/AdminContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminProtectedRoute } from './components/AdminProtectedRoute';
import { DashboardLayout } from './components/DashboardLayout';
import { AdminLayout } from './components/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { NewSoftTokenWizard } from './pages/NewSoftTokenWizard';
import { NewDesktopTokenWizard } from './pages/NewDesktopTokenWizard';
import { ManageTokensPage } from './pages/ManageTokensPage';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { SettingsPage } from './pages/admin/SettingsPage';
import { ActivityLogsPage } from './pages/admin/ActivityLogsPage';
import { AdminAccountsPage } from './pages/admin/AdminAccountsPage';
import { UserManagementPage } from './pages/admin/UserManagementPage';
import { AccountManagementPage } from './pages/admin/AccountManagementPage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <LanguageProvider>
          <AdminProvider>
            <BrowserRouter>
            <Routes>
              {/* User Portal Routes */}
              <Route path="/" element={<LoginPage />} />
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <DashboardLayout>
                      <Routes>
                        <Route index element={<DashboardPage />} />
                        <Route path="new-soft-token" element={<NewSoftTokenWizard />} />
                        <Route path="new-desktop-token" element={<NewDesktopTokenWizard />} />
                        <Route path="manage-tokens" element={<ManageTokensPage />} />
                      </Routes>
                    </DashboardLayout>
                  </ProtectedRoute>
                }
              />
              
              {/* Admin Portal Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/*"
                element={
                  <AdminProtectedRoute>
                    <AdminLayout>
                      <Routes>
                        <Route path="dashboard" element={<AdminDashboard />} />
                        <Route path="settings" element={<SettingsPage />} />
                        <Route path="logs" element={<ActivityLogsPage />} />
                        <Route path="users" element={<UserManagementPage />} />
                        <Route path="account-management" element={<AccountManagementPage />} />
                        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                      </Routes>
                    </AdminLayout>
                  </AdminProtectedRoute>
                }
              />
              
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" />
          </BrowserRouter>
        </AdminProvider>
      </LanguageProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
